'use client';

import { useIntl } from 'react-intl';
import type { PropsWithChildren } from 'react';
import { ratingIconsWithInfoButtonMessages } from './RatingIconsWithInfoButton.messages';

export type RatingIconsWithInfoButtonProps = PropsWithChildren & {
  customerReviewsSectionId: string;
};

export const RatingIconsWithInfoButton = ({
  customerReviewsSectionId,
  children,
}: RatingIconsWithInfoButtonProps) => {
  const { formatMessage } = useIntl();

  const handleScroll = () => {
    const customerReviewsSection = document.getElementById(customerReviewsSectionId);

    if (customerReviewsSection) {
      customerReviewsSection.setAttribute('tabindex', '-1');
      customerReviewsSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
      customerReviewsSection.focus();
      customerReviewsSection.blur();
    }
  };

  return (
    <div
      onClick={(event) => {
        event.currentTarget.blur();
        handleScroll();
      }}
      onKeyDown={(event) => {
        if (event.key === 'Enter') {
          event.currentTarget.blur();
          handleScroll();
        }
      }}
      tabIndex={0}
      role="button"
      className="cursor-pointer"
      aria-label={formatMessage(ratingIconsWithInfoButtonMessages.ariaLabel)}
    >
      {children}
    </div>
  );
};
